import { Box, Typography } from '@mui/material';

export default function AuthBrandPanel({ compact = false }) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        width: '100%'
      }}
    >
      <Box
        component="img"
        src={process.env.REACT_APP_LOGIN}
        alt="The Clutch"
        sx={{ width: compact ? 56 : 72, height: compact ? 56 : 72, objectFit: 'contain' }}
      />
      <Typography
        variant={compact ? 'h4' : 'h3'}
        sx={{ color: '#F3F4F6', fontWeight: 300, mt: compact ? 2 : 3 }}
      >
        The <Box component="span" sx={{ fontWeight: 700 }}>Clutch</Box>
      </Typography>
      <Typography
        sx={{
          color: '#9CA3AF',
          mt: 1.5,
          letterSpacing: '0.08em',
          fontSize: compact ? 11 : 13,
          maxWidth: 280
        }}
      >
        FAST BOWLING. SMARTER WORKLOAD.
      </Typography>
    </Box>
  );
}
